import React, { createContext, useContext } from 'react';
import useStagePanelVisibility from '../hooks/useStagePanelVisibility';

const StagePanelContext = createContext();

export const StagePanelProvider = ({ children }) => {
  const stagePanelState = useStagePanelVisibility();

  return (
    <StagePanelContext.Provider value={stagePanelState}>
      {children}
    </StagePanelContext.Provider>
  );
};

export const useStagePanelContext = () => {
  const context = useContext(StagePanelContext);
  if (!context) {
    throw new Error('useStagePanelContext must be used within StagePanelProvider');
  }
  return context;
};

export default StagePanelContext;
